import React from 'react';

import Quicks from '../../components/quicks';
import Tools from '../../components/tools';
import Datasets from '../../components/datasets';

import './index.css';

const Component = () => {
    return (
        <div className="tools-data">
            <Quicks
                external
                links={[]}
                navs={[
                    { name: 'Tools Developed', link: '#Tools' },
                    { name: 'Datasets', link: '#Datasets' }
                ]}
            />

            <Tools />
            <Datasets />
        </div>
    );
};

export default Component;
